// src/keycloak.ts
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: `${process.env.REACT_APP_KEYCLOCK_BASE_URL}/`,
  realm: 'centurion',
  clientId: 'centurion-ui',
});

export default keycloak;
